module.exports = "/_next/static/images/bfa59b5ed01a4a93e60dd8ae5aec6c7c-estadao-logo.png";